import React from 'react';
import { useTranslation } from 'react-i18next';
import ContactSection from '../ContactSection/Contact';
import './css/Satty_.css';

/* ══════════════════════════════════════════════
   SATTY Landing
   Todos los strings viven en common.json → "satty".
   Compatible con toolchains antiguos (Node 12.x):
   sin optional chaining (?.) ni nullish coalescing (??).
   ══════════════════════════════════════════════ */

var DATA = 'satty';

/* Helper: lee un array desde i18n de forma segura */
function useArray(t, key) {
  var value = t(key, { returnObjects: true });
  return Array.isArray(value) ? value : [];
}

/* ══════════════════════════════════════════════
   Íconos inline (SVG, heredan color con currentColor)
   La clave se deriva del nombre de archivo declarado
   en common.json → p.ej. ".../icons/solar.svg" → "solar".
   ══════════════════════════════════════════════ */

/* Extrae la clave de ícono desde la ruta declarada en i18n */
function iconKey(src) {
  if (!src) return '';
  var file = String(src).split('/').pop();
  return file.replace(/\.[a-z]+$/i, '');
}

var ICON_PATHS = {
  /* Pilares */
  response: 'M13 2 4 14h7l-1 8 9-12h-7l1-8Z',
  satellite: 'M5 13 3 15l3 3 2-2M11 7l2-2 3 3-2 2M6.5 11.5l6-6 3 3-6 6-3-3ZM14 18a4 4 0 0 0 4-4M14 21.5a7.5 7.5 0 0 0 7.5-7.5',
  evidence: 'M9 3h6v3H9V3ZM7 5H5v16h14V5h-2M9 12h6M9 16h4',
  /* Flujo */
  radio: 'M12 12v.01M8.5 8.5a5 5 0 0 0 0 7M15.5 8.5a5 5 0 0 1 0 7M5.5 5.5a9 9 0 0 0 0 13M18.5 5.5a9 9 0 0 1 0 13',
  rules: 'M4 6h10M4 12h16M4 18h7M17 4v4M17 6h3M14 16v4M14 18h6',
  alert: 'M12 4a5 5 0 0 0-5 5v4l-2 3h14l-2-3V9a5 5 0 0 0-5-5ZM10 19a2 2 0 0 0 4 0',
  act: 'M12 3v6M5.6 5.6l2.2 2.2M18.4 5.6l-2.2 2.2M4 14h16a8 8 0 0 1-16 0ZM7 18l-1 3M17 18l1 3',
  /* Red SATTY */
  solar: 'M12 2v3M4.2 5.2l2.1 2.1M2 13h3M19 13h3M17.7 7.3l2.1-2.1M12 8a5 5 0 0 1 5 5H7a5 5 0 0 1 5-5ZM4 17h16l-1 4H5l-1-4ZM12 17v4',
  climate: 'M10 4v9a3 3 0 1 0 4 0V4a2 2 0 0 0-4 0ZM14 8h3M14 11h3M12 13v4',
  redundancy: 'M12 3v4M12 17v4M4.9 7.5 8.4 9.5M15.6 14.5l3.5 2M4.9 16.5l3.5-2M15.6 9.5l3.5-2M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z',
  predictive: 'M4 20h16M6 16l4-4 3 3 5-6M16 9h3v3',
  /* Failover */
  'signal-off': 'M3 3l18 18M8.5 15.5a5 5 0 0 1 0-7M5.5 18.5a9 9 0 0 1-1.4-11M15.5 8.5a5 5 0 0 1 1.2 4.5M18.5 5.5a9 9 0 0 1 1.6 8M12 12v.01',
  switch: 'M3 7h4l3 3.5M3 17h4l8-10h4M14 14.5l1.5 2H19M17 4l3 3-3 3M17 13.5l3 3-3 3',
  'check-circle': 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM8.2 12.2l2.6 2.6 5-5.4',
  backup: 'M12 3c-3.9 0-7 1.1-7 2.5S8.1 8 12 8s7-1.1 7-2.5S15.9 3 12 3ZM5 5.5v13c0 1.4 3.1 2.5 7 2.5s7-1.1 7-2.5v-13M5 12c0 1.4 3.1 2.5 7 2.5s7-1.1 7-2.5',
  cellular: 'M4 20V10M9 20V6M14 20v-8M19 20V4',
  /* Pipeline: los cinco pasos del flujo */
  detect: 'M2.5 12H7l2.5-6.5 5 13 2.5-6.5H21',
  audience: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM12 7.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM12 11.2a.8.8 0 1 0 0 1.6.8.8 0 0 0 0-1.6Z',
  compose: 'M4 20l1.2-4.4L16 4.8l3.2 3.2L8.4 18.8 4 20ZM13.6 7.2l3.2 3.2',
  emission: 'M21 3 10.5 13.5M21 3l-6.5 18-4-7.5L3 9.5 21 3Z',
  /* Canales de notificación */
  mail: 'M3 6h18v12H3zM3 7l9 6 9-6',
  /* Burbuja de mensaje corto: SMS que llega sin datos móviles */
  sms: 'M5 5h14a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H9.5L5 20V6a1 1 0 0 1 0-1ZM8.5 10.5h.01M12 10.5h.01M15.5 10.5h.01',
  /* Grupo de personas: la comunidad que recibe el aviso */
  community: 'M9.5 11.2a3.1 3.1 0 1 0 0-6.2 3.1 3.1 0 0 0 0 6.2ZM3.5 19.5a6 6 0 0 1 12 0M16.8 11a2.6 2.6 0 1 0 0-5.2M17.4 13.3a5.2 5.2 0 0 1 3.6 4.6',
  /* Burbuja de chat con auricular: evoca WhatsApp sin copiar la marca */
  whatsapp: 'M12 3a9 9 0 0 0-7.7 13.7L3 21l4.4-1.3A9 9 0 1 0 12 3ZM9.5 8.5c.4 1.2 1 2.2 1.8 3s1.8 1.4 3 1.8l1-1.2 1.9.9-.4 1.7c-1.9.3-3.9-.6-5.4-2.1s-2.4-3.5-2.1-5.4l1.7-.4.9 1.9-1.4.8',
  push: 'M8 3h8a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2ZM10 18h4M12 7a3 3 0 0 0-3 3v2l-1 1.5h8L15 12v-2a3 3 0 0 0-3-3Z',
  /* Casos de uso de la notificación */
  cold: 'M12 3v18M12 7.5 8.5 5M12 7.5 15.5 5M12 16.5 8.5 19M12 16.5l3.5 2.5M4 7.5l16 9M4 7.5l.5 4.2M4 7.5l4.2-.6M20 16.5l-.5-4.2M20 16.5l-4.2.6M20 7.5l-16 9M20 7.5l-4.2-.6M20 7.5l-.5 4.2M4 16.5l.5-4.2M4 16.5l4.2.6',
  air: 'M3 8h11a3 3 0 1 0-3-3M3 12h15a3 3 0 1 1-3 3M3 16h9a2.5 2.5 0 1 1-2.5 2.5',
  /* Lluvia: acumulado histórico e intensidad instantánea */
  rainfall: 'M4 21h16M7 21v-4M11 21v-7M15 21v-3M19 21v-9M12 3c1.5 1.9 2.3 3.2 2.3 4.1a2.3 2.3 0 0 1-4.6 0C9.7 6.2 10.5 4.9 12 3Z',
  intensity: 'M6 3v4M12 2v5M18 3v4M6.5 12c1 1.3 1.6 2.2 1.6 2.9a1.6 1.6 0 0 1-3.2 0c0-.7.6-1.6 1.6-2.9ZM12 14c1 1.3 1.6 2.2 1.6 2.9a1.6 1.6 0 0 1-3.2 0c0-.7.6-1.6 1.6-2.9ZM17.5 12c1 1.3 1.6 2.2 1.6 2.9a1.6 1.6 0 0 1-3.2 0c0-.7.6-1.6 1.6-2.9Z',
  /* Suite */
  reports: 'M4 20h16M7 17V9M12 17V5M17 17v-6',
  /* Genéricos */
  photo: 'M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1ZM3 16l5-5 4 4 3-3 6 6M9.5 9.5a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0Z',
  device: 'M8 8h8v8H8zM6 3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3ZM9 3V1M15 3V1M9 23v-2M15 23v-2M3 9H1M3 15H1M23 9h-2M23 15h-2',
  /* Casos de uso */
  industry: 'M3 21h18M4 21V11l5 3V11l5 3V8l5 3v10M8 17h1M13 17h1M18 17h1',
  flood: 'M12 3s5 5.5 5 9a5 5 0 0 1-10 0c0-3.5 5-9 5-9ZM3 20c1.5-1.2 3-1.2 4.5 0S10.5 21.2 12 20s3-1.2 4.5 0 3 1.2 4.5 0',
  agro: 'M12 21V9M12 13c0-3.5 2.5-6 6-6 0 3.5-2.5 6-6 6ZM12 16c0-3-2.2-5.2-5.2-5.2 0 3 2.2 5.2 5.2 5.2Z',
};

var ICON_FALLBACK = 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM12 8v5M12 16v.01';

function SattyIcon(props) {
  var key = props.name || '';
  var d = ICON_PATHS[key] || ICON_FALLBACK;
  var size = props.size || 24;
  return (
    <svg
      className="satty-icon"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d={d} />
    </svg>
  );
}

/* ─── Logo SVG (marca Satty: sirena + ondas) ─── */
function SattyLogo(props) {
  var size = props.size || 30;
  var withOuterWave = props.withOuterWave !== false;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      aria-hidden="true"
      focusable="false"
    >
      <line x1="60" y1="60" x2="60" y2="98" stroke="#F2F8F5" strokeWidth="7" strokeLinecap="round" />
      <line x1="49" y1="98" x2="71" y2="98" stroke="#F2F8F5" strokeWidth="7" strokeLinecap="round" />
      <path d="M42 46 A26 26 0 0 1 78 46" fill="none" stroke="#34C7A0" strokeWidth="7" strokeLinecap="round" />
      {withOuterWave && (
        <path d="M30 37 A42 42 0 0 1 90 37" fill="none" stroke="#34C7A0" strokeWidth="7" strokeLinecap="round" opacity="0.45" />
      )}
      <circle cx="60" cy="54" r="6.5" fill="#F2F8F5" />
    </svg>
  );
}

/* ─── Isotipo Satty (app icon: marca sobre cuadro redondeado) ───
   Vector oficial del ícono de aplicación. Se usa como ancla de marca en el
   hero; a diferencia de SattyLogo (solo la marca), incluye el cuadro oscuro. */
function SattyIsotipo(props) {
  var size = props.size || 64;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      role="img"
      aria-label="Satty"
      focusable="false"
    >
      <rect width="120" height="120" rx="27" fill="#0C1B24" />
      <line x1="60" y1="56" x2="60" y2="96" stroke="#F4F7F6" strokeWidth="8" strokeLinecap="round" />
      <line x1="48" y1="96" x2="72" y2="96" stroke="#F4F7F6" strokeWidth="8" strokeLinecap="round" />
      <path d="M44 42 A22 22 0 0 1 76 42" stroke="#34C7A0" strokeWidth="7" strokeLinecap="round" />
      <path d="M34 34 A36 36 0 0 1 86 34" stroke="#34C7A0" strokeWidth="6" strokeLinecap="round" opacity="0.5" />
      <circle cx="60" cy="50" r="6" fill="#34C7A0" />
    </svg>
  );
}

/* ─── NAV ─── */
function SattyNav() {
  var t = useTranslation('common')[0];
  var links = useArray(t, DATA + '.nav.links');
  return (
    <header className="satty-nav">
      <nav className="satty-nav-inner">
        <a href="#top" className="satty-nav-brand">
          <SattyLogo size={30} />
          <span className="satty-nav-brand-name">{t(DATA + '.nav.brand')}</span>
        </a>
        <div className="satty-nav-right">
          <div className="satty-nav-links">
            {links.map(function (link, i) {
              return (
                <a key={i} href={link.href}>
                  {link.label}
                </a>
              );
            })}
          </div>
          <a href="#contact" className="satty-btn satty-btn--primary satty-btn--sm">
            {t(DATA + '.nav.cta')}
          </a>
        </div>
      </nav>
    </header>
  );
}

/* ─── HERO (opción B: panel de lectura + foto a sangre) ─── */
function SattyHero() {
  var t = useTranslation('common')[0];
  var chips = useArray(t, DATA + '.hero.chips');
  return (
    <section id="top" className="satty-screen satty-hero">
      <div className="satty-hero-inner">
        <div className="satty-hero-copy">
          <span className="satty-hero-isotipo">
            <SattyIsotipo size={64} />
          </span>
          <span className="satty-hero-eyebrow">{t(DATA + '.hero.eyebrow')}</span>
          <h1 className="satty-hero-title">{t(DATA + '.hero.title')}</h1>
          <p className="satty-hero-text">
            {t(DATA + '.hero.text_pre')}
            <strong>{t(DATA + '.hero.text_strong')}</strong>
            {t(DATA + '.hero.text_post')}
          </p>
          <div className="satty-hero-ctas">
            <a href="#contact" className="satty-btn satty-btn--primary">
              {t(DATA + '.hero.cta_primary')}
            </a>
            <a href="#plataforma" className="satty-btn satty-btn--ghost">
              {t(DATA + '.hero.cta_secondary')}
            </a>
          </div>
          <div className="satty-hero-chips">
            {chips.map(function (chip, i) {
              return (
                <span key={i} className="satty-hero-chip">
                  {chip}
                </span>
              );
            })}
          </div>
        </div>
        <div className="satty-hero-visual">
          <img
            className="satty-hero-photo-img"
            src={t(DATA + '.hero.img_main')}
            alt={t(DATA + '.hero.img_main_alt')}
          />
          <div className="satty-hero-photo-blend" />
          <div className="satty-hero-live">
            <span className="satty-hero-live-dot" />
            {t(DATA + '.hero.live_badge')}
          </div>
        </div>
      </div>
    </section>
  );
}


/* ══════════════════════════════════════════════
   Escena de plataforma: estación IoT → nube → dashboard y app → alerta
   Vive sobre el panel oscuro de pilares, así que los trazos usan la escala
   on-dark (p-800 estructura, mint dato, mint-light acento).
   ══════════════════════════════════════════════ */
function SattyPlatformArt() {
  return (
    <svg
      className="satty-pillars-art"
      viewBox="0 0 420 340"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      {/* ── Estación automática con sensores ── */}
      <g stroke="var(--satty-p-800)" strokeWidth="2" strokeLinecap="round" opacity="0.9">
        <path d="M24 300h116" opacity="0.4" />
        <path d="M58 300 78 196M98 300 78 196" />
        <path d="M66 278h24M70 252h16M74 228h8" />
        <path d="M78 196v-18" />
      </g>
      {/* Panel solar en escorzo */}
      <g stroke="var(--satty-p-800)" strokeWidth="2" strokeLinejoin="round">
        <path d="M40 192l26-13 24 11-26 13Z" fill="var(--satty-forest)" />
        <path d="M48 188.5l24 11M58 183.5l24 11" strokeWidth="1.2" opacity="0.55" />
      </g>
      {/* Caja de sensores */}
      <g stroke="var(--satty-p-800)" strokeWidth="2" strokeLinejoin="round">
        <rect x="60" y="246" width="26" height="22" rx="4" fill="var(--satty-forest)" />
        <path d="M66 253h14M66 259h9" strokeWidth="1.4" opacity="0.6" />
      </g>
      {/* Emisión desde la antena */}
      <g stroke="var(--satty-mint)" strokeWidth="2" strokeLinecap="round" fill="none">
        <path d="M86 172a12 12 0 0 0 0-14" opacity="0.55" />
        <path d="M93 178a21 21 0 0 0 0-26" opacity="0.3" />
      </g>

      {/* ── Nube: los datos suben ── */}
      <g>
        <g fill="var(--satty-forest)" stroke="var(--satty-mint-light)" strokeWidth="2">
          <path d="M170 92a20 20 0 0 1 3-39 26 26 0 0 1 48-6 17 17 0 0 1 14 45Z" />
        </g>
        <g stroke="var(--satty-mint)" strokeWidth="2" strokeLinecap="round">
          <path d="M196 78V60M190 66l6-6 6 6" />
        </g>
      </g>

      {/* ── Dashboard con serie de tiempo ── */}
      <g>
        <rect x="252" y="96" width="150" height="112" rx="10" fill="var(--satty-forest)" stroke="var(--satty-p-800)" strokeWidth="2" />
        <g stroke="var(--satty-p-800)" strokeWidth="1.6" strokeLinecap="round" opacity="0.5">
          <path d="M252 114h150" />
          <path d="M266 190h122M272 190v-58" />
        </g>
        <g fill="var(--satty-p-800)" opacity="0.55">
          <circle cx="264" cy="105" r="2.5" />
          <circle cx="274" cy="105" r="2.5" />
          <circle cx="284" cy="105" r="2.5" />
        </g>
        {/* Umbral y serie */}
        <path d="M272 146h116" stroke="var(--satty-mint-light)" strokeWidth="1.6" strokeDasharray="4 5" opacity="0.7" />
        <path d="M272 178l16-9 15 6 15-16 14 9 14-24 14 12 14-20" stroke="var(--satty-mint)" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="360" cy="132" r="4" fill="var(--satty-mint)" />
      </g>

      {/* ── App móvil ── */}
      <g>
        <rect x="252" y="228" width="74" height="106" rx="12" fill="var(--satty-forest)" stroke="var(--satty-p-800)" strokeWidth="2" />
        <path d="M280 238h18" stroke="var(--satty-p-800)" strokeWidth="2" strokeLinecap="round" opacity="0.6" />
        <path d="M262 296l11-8 10 5 10-13 11 8" stroke="var(--satty-mint)" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
        <g stroke="var(--satty-p-800)" strokeWidth="1.6" strokeLinecap="round" opacity="0.45">
          <path d="M262 312h40M262 320h26" />
        </g>
      </g>

      {/* ── Notificación de alerta ── */}
      <g>
        <rect x="336" y="242" width="72" height="56" rx="12" fill="var(--satty-mint)" fillOpacity="0.14" stroke="var(--satty-mint)" strokeWidth="2" />
        <g stroke="var(--satty-mint-light)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M372 258a7 7 0 0 0-7 7v5l-3 4h20l-3-4v-5a7 7 0 0 0-7-7ZM369 278a3 3 0 0 0 6 0" />
        </g>
        <g stroke="var(--satty-mint-light)" strokeWidth="1.6" strokeLinecap="round" opacity="0.5">
          <path d="M352 288h40" />
        </g>
      </g>

      {/* ── Enlaces del recorrido ── */}
      <g stroke="var(--satty-mint)" strokeWidth="2" strokeLinecap="round" strokeDasharray="5 7" fill="none" opacity="0.75">
        <path d="M100 158q40-52 82-58" />
        <path d="M244 88q30 4 44 6" />
        <path d="M228 108q-4 60 20 118" />
      </g>
      <g fill="var(--satty-mint)">
        <path d="M292 95l-9-3 1 7Z" />
        <path d="M251 224l-3-9 7 1Z" />
      </g>
    </svg>
  );
}

/* ─── PILARES ─── */
function SattyPillars() {
  var t = useTranslation('common')[0];
  var items = useArray(t, DATA + '.pillars.items');
  return (
    <section id="plataforma" className="satty-screen satty-section satty-pillars">
      <div className="satty-pillars-panel">
        <div className="satty-section-head">
          <span className="satty-eyebrow">{t(DATA + '.pillars.label')}</span>
          <h2 className="satty-h2">{t(DATA + '.pillars.title')}</h2>
        </div>
        <div className="satty-grid-3">
          {items.map(function (item, i) {
            return (
              <article key={i} className="satty-pillar">
                {/* Espacio de imagen: si `photo` está vacío en i18n se muestra
                    el marco de reserva, sin romper el alto de la tarjeta */}
                <div className="satty-pillar-photo">
                  {item.photo ? (
                    <img src={item.photo} alt={item.photo_alt} />
                  ) : (
                    <span className="satty-pillar-photo-ph">
                      <SattyIcon name="photo" size={24} />
                    </span>
                  )}
                </div>
                <div className="satty-pillar-body">
                  <div className="satty-card-icon satty-card-icon--soft">
                    <SattyIcon name={iconKey(item.img)} size={24} />
                  </div>
                  <h3 className="satty-pillar-title">{item.title}</h3>
                  <p className="satty-pillar-text">{item.text}</p>
                </div>
                {/* Banda inferior: el pilar aterrizado en un caso real */}
                <div className="satty-pillar-case">
                  <span className="satty-pillar-case-label">{item.case_label}</span>
                  <p className="satty-pillar-case-text">{item.case_text}</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}

/* ─── FLUJO: SENSA → REGLAS → ALERTA → ACTÚA ─── */
function SattyFlow() {
  var t = useTranslation('common')[0];
  var steps = useArray(t, DATA + '.flow.steps');
  return (
    <section className="satty-screen satty-flow">
      <div className="satty-flow-inner">
        <div className="satty-section-head">
          <span className="satty-eyebrow">{t(DATA + '.flow.label')}</span>
          <h2 className="satty-h2">{t(DATA + '.flow.title')}</h2>
          <p className="satty-lead">{t(DATA + '.flow.text')}</p>
        </div>
        <div className="satty-grid-4">
          {steps.map(function (step, i) {
            var isLast = i === steps.length - 1;
            return (
              <div key={i} className={'satty-flow-step' + (isLast ? ' satty-flow-step--accent' : '')}>
                <span className="satty-flow-num">{step.num}</span>
                <div className="satty-flow-icon">
                  <SattyIcon name={iconKey(step.img)} size={28} />
                </div>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

/* Conector entre etapas del pipeline. En una sola columna (≤1024px) el CSS
   lo gira 90° para que siga leyéndose como "y después". */
function PipeArrow() {
  return (
    <span className="satty-pipe-arrow" aria-hidden="true">
      <svg viewBox="0 0 28 16" width="28" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M1 8h24M19 2l6 6-6 6" />
      </svg>
    </span>
  );
}

/* Resumen del flujo: los cinco pasos como diagrama de nodos conectados,
   sin numeración — el orden lo da la propia línea. */
function SattyPipeRail(props) {
  var steps = props.steps || [];
  return (
    <div className="satty-pipe-rail">
      {steps.map(function (step, i) {
        return (
          <React.Fragment key={i}>
            {i > 0 && (
              <span className="satty-pipe-rail-link" aria-hidden="true">
                <svg viewBox="0 0 20 12" width="20" height="12" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M1 6h16M13 2l4 4-4 4" />
                </svg>
              </span>
            )}
            <div className={'satty-pipe-rail-node' + (step.tone ? ' satty-pipe-rail-node--' + step.tone : '')}>
              <span className="satty-pipe-rail-chip">
                <SattyIcon name={step.icon} size={18} />
              </span>
              <span className="satty-pipe-rail-name">{step.title}</span>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}

/* ─── PIPELINE: DE LA DETECCIÓN A LA COMUNIDAD ───
   Expande los 4 pasos de SattyFlow en las tres zonas donde ocurre el trabajo:
   la estación (offline), la consola en la nube y la comunidad. */
function SattyPipeline() {
  var t = useTranslation('common')[0];
  var station = t(DATA + '.pipeline.station', { returnObjects: true }) || {};
  var consoleSteps = useArray(t, DATA + '.pipeline.console');
  var channels = useArray(t, DATA + '.pipeline.channels');
  var emission = t(DATA + '.pipeline.emission', { returnObjects: true }) || {};
  var audience = t(DATA + '.pipeline.audience', { returnObjects: true }) || {};

  var railSteps = [{ icon: iconKey(station.img), title: station.title, tone: 'mint' }]
    .concat(consoleSteps.map(function (step) {
      return { icon: iconKey(step.img), title: step.title, tone: '' };
    }))
    .concat([{ icon: iconKey(emission.img), title: emission.title, tone: 'emerald' }]);

  return (
    <section id="flujo" className="satty-section satty-pipeline">
      <div className="satty-section-head">
        <span className="satty-eyebrow">{t(DATA + '.pipeline.label')}</span>
        <h2 className="satty-h2">{t(DATA + '.pipeline.title')}</h2>
      </div>

      <SattyPipeRail steps={railSteps} />

      <div className="satty-pipeline-track">
        {/* 1 · En la estación: la regla se evalúa sin depender de la nube */}
        <article className="satty-pipe-station">
          <div className="satty-pipe-head">
            <span className="satty-pipe-ico satty-pipe-ico--mint">
              <SattyIcon name={iconKey(station.img)} size={18} />
            </span>
            <h3 className="satty-pipe-stage">{station.title}</h3>
          </div>
          <span className="satty-pipe-zone satty-pipe-zone--mint">
            {t(DATA + '.pipeline.station_label')}
          </span>

          <div className="satty-pipe-role">
            <div className="satty-card-icon satty-card-icon--glass">
              <SattyIcon name={iconKey(station.role_img)} size={24} />
            </div>
            <div>
              <div className="satty-pipe-role-title">{station.role_title}</div>
              <p className="satty-pipe-role-text">{station.role_text}</p>
            </div>
          </div>

          <div className="satty-pipe-rule">
            <div className="satty-pipe-rule-expr">{station.rule}</div>
            <span className="satty-pipe-rule-state">
              <SattyIcon name={iconKey(station.rule_state_img)} size={16} />
              {station.rule_state}
            </span>
            <p className="satty-pipe-rule-note">{station.rule_note}</p>
          </div>
        </article>

        <PipeArrow />

        {/* 2-4 · En la consola: lo único manual es redactar y confirmar */}
        <div className="satty-pipe-console">
          <span className="satty-pipe-zone">{t(DATA + '.pipeline.console_label')}</span>
          {consoleSteps.map(function (step, i) {
            var tags = Array.isArray(step.tags) ? step.tags : [];
            return (
              <article key={i} className="satty-pipe-card">
                <span className="satty-pipe-ico">
                  <SattyIcon name={iconKey(step.img)} size={18} />
                </span>
                <div className="satty-pipe-card-body">
                  <h4 className="satty-pipe-card-title">{step.title}</h4>
                  <p className="satty-pipe-card-text">{step.text}</p>
                </div>
                <div className="satty-pipe-card-aside">
                  {tags.length > 0 && (
                    <div className="satty-pipe-tags">
                      {tags.map(function (tag, j) {
                        return (
                          <span key={j} className="satty-pipe-tag">{tag}</span>
                        );
                      })}
                    </div>
                  )}
                  {step.preview_title && (
                    <div className="satty-pipe-preview">
                      <div className="satty-pipe-preview-title">{step.preview_title}</div>
                      <p className="satty-pipe-preview-text">{step.preview_text}</p>
                    </div>
                  )}
                  {step.totals && (
                    <div className="satty-pipe-confirm">
                      <span className="satty-pipe-totals">{step.totals}</span>
                      <span className="satty-pipe-confirm-btn">{step.action}</span>
                    </div>
                  )}
                </div>
              </article>
            );
          })}
        </div>

        <PipeArrow />

        {/* 5 · A la comunidad: los cuatro canales convergen en un mismo aviso */}
        <div className="satty-pipe-community">
          <span className="satty-pipe-zone">{t(DATA + '.pipeline.community_label')}</span>
          <div className="satty-pipe-head">
            <span className="satty-pipe-ico satty-pipe-ico--emerald">
              <SattyIcon name={iconKey(emission.img)} size={18} />
            </span>
            <h3 className="satty-pipe-stage satty-pipe-stage--ink">{emission.title}</h3>
          </div>

          <ul className="satty-pipe-channels">
            {channels.map(function (channel, i) {
              return (
                <li key={i} className="satty-pipe-channel">
                  <div className="satty-card-icon satty-card-icon--soft">
                    <SattyIcon name={iconKey(channel.img)} size={22} />
                  </div>
                  <div>
                    <div className="satty-pipe-channel-title">{channel.title}</div>
                    <div className="satty-pipe-channel-text">{channel.text}</div>
                  </div>
                </li>
              );
            })}
          </ul>

          <div className="satty-pipe-audience">
            <div className="satty-card-icon satty-card-icon--soft">
              <SattyIcon name={iconKey(audience.img)} size={24} />
            </div>
            <span className="satty-pipe-audience-title">{audience.title}</span>
          </div>
        </div>
      </div>

      <p className="satty-pipeline-footnote">{t(DATA + '.pipeline.footnote')}</p>
    </section>
  );
}

/* ─── RED SATTY: CONDICIONES EXTREMAS ─── */
function SattyNetwork() {
  var t = useTranslation('common')[0];
  var features = useArray(t, DATA + '.network.features');
  return (
    <section id="red" className="satty-screen satty-network">
      <div className="satty-network-inner satty-bleed-inner">
        <div className="satty-network-photo satty-bleed-photo">
          <img src={t(DATA + '.network.img')} alt={t(DATA + '.network.img_alt')} />
        </div>
        <div className="satty-bleed-copy satty-bleed-copy--right">
          <span className="satty-eyebrow">{t(DATA + '.network.label')}</span>
          <h2 className="satty-h2">{t(DATA + '.network.title')}</h2>
          <p className="satty-lead satty-network-lead">{t(DATA + '.network.text')}</p>
          <div className="satty-network-list">
            {features.map(function (item, i) {
              return (
                <div key={i} className="satty-network-item">
                  <div className="satty-card-icon satty-card-icon--soft">
                    <SattyIcon name={iconKey(item.img)} size={24} />
                  </div>
                  <div>
                    <div className="satty-network-item-title">{item.title}</div>
                    <div className="satty-network-item-text">{item.text}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

/* ══════════════════════════════════════════════
   Escenas vectoriales del failover
   Una por paso, mismo lienzo (240×150) y misma línea de horizonte (y=120)
   para que las tres lean como una secuencia. Los colores salen de las vars
   de marca, así que siguen el tema de la página.
   ══════════════════════════════════════════════ */

/* Torre de la estación: patas, travesaños y mástil */
function ArtTower(props) {
  var x = props.x;
  return (
    <g transform={'translate(' + x + ' 0)'} fill="none" stroke="var(--satty-p-100)" strokeWidth="2.4" strokeLinecap="round">
      <path d="M-14 120 3 56M14 120-3 56" />
      <path d="M-9 98h18M-6 80h12M-3 66h6" />
      <path d="M0 56V44" />
    </g>
  );
}

/* Suelo de campo, común a las tres escenas */
function ArtGround() {
  return <path d="M14 120h212" stroke="var(--satty-n-200)" strokeWidth="2.5" strokeLinecap="round" />;
}

var FAILOVER_ART = {
  /* 1 · Cae la red celular: tormenta encima, ondas rotas y enlace tachado */
  'signal-off': (
    <g>
      <g fill="var(--satty-n-200)">
        <circle cx="168" cy="36" r="17" />
        <circle cx="192" cy="40" r="12" />
        <circle cx="148" cy="42" r="12" />
        <rect x="148" y="40" width="46" height="14" rx="7" />
      </g>
      <g stroke="var(--satty-n-400)" strokeWidth="2.2" strokeLinecap="round" opacity="0.75">
        <path d="M154 62l-5 12M172 62l-5 12M190 62l-5 12" />
      </g>
      <ArtTower x="70" />
      <g stroke="var(--satty-n-400)" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeDasharray="3 6">
        <path d="M86 52a16 16 0 0 1 0 22" />
        <path d="M95 44a27 27 0 0 1 0 38" />
      </g>
      <g stroke="var(--satty-n-500)" strokeWidth="2.8" strokeLinecap="round">
        <path d="M112 54l16 16M128 54l-16 16" />
      </g>
      <ArtGround />
    </g>
  ),

  /* 2 · Conmuta a RF: el enlace celular queda tachado, el propio toma el relevo */
  switch: (
    <g>
      <ArtTower x="52" />
      <g fill="none" strokeLinecap="round">
        <path d="M66 48q52-34 104 6" stroke="var(--satty-n-400)" strokeWidth="2.2" strokeDasharray="3 6" opacity="0.55" />
        <path d="M118 24l12 12M130 24l-12 12" stroke="var(--satty-n-500)" strokeWidth="2.4" opacity="0.55" />
        <path d="M70 78q48 20 92-4" stroke="var(--satty-mint)" strokeWidth="2.8" />
        <path d="M162 74l-9 1M162 74l-3-8" stroke="var(--satty-mint)" strokeWidth="2.8" />
      </g>
      <g transform="translate(186 0)" fill="none" stroke="var(--satty-p-100)" strokeWidth="2.4" strokeLinecap="round">
        <path d="M0 120V62" />
        <path d="M-10 58l10-10 10 10M-7 46l7-7 7 7" stroke="var(--satty-mint)" />
      </g>
      <ArtGround />
    </g>
  ),

  /* 3 · Dato en la nube: paquetes subiendo y confirmación */
  'check-circle': (
    <g>
      <g>
        <circle cx="150" cy="40" r="19" fill="var(--satty-mint)" fillOpacity="0.16" />
        <circle cx="176" cy="44" r="13" fill="var(--satty-mint)" fillOpacity="0.16" />
        <circle cx="128" cy="46" r="13" fill="var(--satty-mint)" fillOpacity="0.16" />
        <rect x="128" y="44" width="48" height="14" rx="7" fill="var(--satty-mint)" fillOpacity="0.16" />
        <path d="M141 44l7 7 13-14" fill="none" stroke="var(--satty-s-600)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <ArtTower x="52" />
      <g fill="var(--satty-mint)">
        <rect x="76" y="86" width="11" height="11" rx="3" opacity="0.35" />
        <rect x="96" y="70" width="11" height="11" rx="3" opacity="0.6" />
        <rect x="116" y="56" width="11" height="11" rx="3" opacity="0.9" />
      </g>
      <ArtGround />
    </g>
  ),
};

/* Lienzo compartido: si un paso no tiene escena, no rompe el layout */
function SattyFailoverArt(props) {
  var scene = FAILOVER_ART[props.name];
  if (!scene) return null;
  return (
    <svg
      className="satty-failover-art"
      viewBox="0 0 240 150"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      {scene}
    </svg>
  );
}

/* ─── FAILOVER: PASO A PASO DE UNA CAÍDA DE ENLACE ─── */
function SattyFailover() {
  var t = useTranslation('common')[0];
  var steps = useArray(t, DATA + '.failover.steps');
  var tags = useArray(t, DATA + '.failover.tags');
  return (
    <section id="failover" className="satty-section satty-failover">
      <div className="satty-failover-panel">
        <div className="satty-failover-head">
          <span className="satty-eyebrow">{t(DATA + '.failover.label')}</span>
          <h2 className="satty-h2">{t(DATA + '.failover.title')}</h2>
          <p className="satty-lead">{t(DATA + '.failover.text')}</p>
        </div>
        <ol className="satty-failover-steps">
          {steps.map(function (step, i) {
            return (
              <li
                key={i}
                className={'satty-failover-step' + (step.highlight ? ' satty-failover-step--done' : '')}
              >
                <div className="satty-failover-art-frame">
                  <SattyFailoverArt name={iconKey(step.img)} />
                </div>
                <span className="satty-failover-time">{step.time}</span>
                <h3 className="satty-failover-step-title">
                  <SattyIcon name={iconKey(step.img)} size={20} />
                  {step.title}
                </h3>
                <p className="satty-failover-step-text">{step.text}</p>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}

/* ─── CONECTIVIDAD ─── */
function SattyConnectivity() {
  var t = useTranslation('common')[0];
  var channels = useArray(t, DATA + '.connectivity.channels');
  return (
    <section className="satty-screen satty-connectivity">
      <div className="satty-connectivity-panel">
        <div className="satty-section-head satty-section-head--on-dark">
          <span className="satty-eyebrow satty-eyebrow--mint">{t(DATA + '.connectivity.label')}</span>
          <h2 className="satty-h2">{t(DATA + '.connectivity.title')}</h2>
          <p className="satty-lead">{t(DATA + '.connectivity.text')}</p>
        </div>
        <div className="satty-grid-3">
          {channels.map(function (channel, i) {
            return (
              <div key={i} className="satty-channel">
                <div className="satty-card-icon satty-card-icon--glass">
                  <SattyIcon name={iconKey(channel.img)} size={24} />
                </div>
                <h3>{channel.title}</h3>
                <p>{channel.text}</p>
              </div>
            );
          })}
        </div>
        <p className="satty-connectivity-footnote">
          <strong>{t(DATA + '.connectivity.footnote_strong')}</strong>
          {t(DATA + '.connectivity.footnote')}
        </p>
      </div>
    </section>
  );
}

/* ─── ALERTAS: CANALES, DESTINATARIOS E INFORMES ─── */
function SattyAlerts() {
  var t = useTranslation('common')[0];
  var channels = useArray(t, DATA + '.alerts.channels');
  var recipients = useArray(t, DATA + '.alerts.routing.recipients');
  var cases = useArray(t, DATA + '.alerts.cases');
  return (
    <section id="alertas" className="satty-section satty-alerts">
      <div className="satty-section-head">
        <span className="satty-eyebrow">{t(DATA + '.alerts.label')}</span>
        <h2 className="satty-h2">{t(DATA + '.alerts.title')}</h2>
        <p className="satty-lead">{t(DATA + '.alerts.text')}</p>
      </div>

      <div className="satty-alerts-layout">
        <div className="satty-alerts-channels">
          <span className="satty-alerts-subhead">{t(DATA + '.alerts.channels_label')}</span>
          {channels.map(function (channel, i) {
            return (
              <article key={i} className="satty-alerts-channel">
                <div className="satty-card-icon satty-card-icon--soft">
                  <SattyIcon name={iconKey(channel.img)} size={24} />
                </div>
                <div>
                  <h3 className="satty-alerts-channel-title">{channel.title}</h3>
                  <p className="satty-alerts-channel-text">{channel.text}</p>
                </div>
              </article>
            );
          })}
        </div>

        {/* Ejemplo de reparto: un evento y a quién despierta, por qué canal */}
        <div className="satty-alerts-routing">
          <div className="satty-alerts-event">
            <div className="satty-alerts-event-head">
              <span className="satty-alerts-badge">
                <span className="satty-alerts-badge-dot" />
                {t(DATA + '.alerts.routing.badge')}
              </span>
              <span className="satty-alerts-event-time">{t(DATA + '.alerts.routing.time')}</span>
            </div>
            <h3 className="satty-alerts-event-title">{t(DATA + '.alerts.routing.event_title')}</h3>
            <p className="satty-alerts-event-text">{t(DATA + '.alerts.routing.event_text')}</p>
          </div>

          <span className="satty-alerts-subhead">{t(DATA + '.alerts.routing.recipients_label')}</span>
          <ul className="satty-alerts-recipients">
            {recipients.map(function (person, i) {
              var tags = Array.isArray(person.channels) ? person.channels : [];
              return (
                <li key={i} className="satty-alerts-recipient">
                  <div className="satty-alerts-recipient-who">
                    <span className="satty-alerts-recipient-role">{person.role}</span>
                    <span className="satty-alerts-recipient-detail">{person.detail}</span>
                  </div>
                  <div className="satty-alerts-recipient-channels">
                    {tags.map(function (tag, j) {
                      return (
                        <span key={j} className="satty-alerts-chip">{tag}</span>
                      );
                    })}
                  </div>
                </li>
              );
            })}
          </ul>
          <p className="satty-alerts-routing-footnote">{t(DATA + '.alerts.routing.footnote')}</p>
        </div>
      </div>

      <div className="satty-alerts-cases">
        <span className="satty-alerts-subhead">{t(DATA + '.alerts.cases_label')}</span>
        <div className="satty-grid-3">
          {cases.map(function (item, i) {
            return (
              <article key={i} className="satty-alerts-case">
                <div className="satty-card-icon satty-card-icon--soft satty-card-icon--lg">
                  <SattyIcon name={iconKey(item.img)} size={24} />
                </div>
                <h3 className="satty-alerts-case-title">{item.title}</h3>
                <p className="satty-alerts-case-text">{item.text}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}

/* ─── SUITE CLOUD ─── */
function SattySuite() {
  var t = useTranslation('common')[0];
  var features = useArray(t, DATA + '.suite.features');
  return (
    <section id="suite" className="satty-screen satty-suite">
      <div className="satty-suite-inner satty-split satty-split--suite">
        <div>
          <span className="satty-eyebrow satty-eyebrow--mint">{t(DATA + '.suite.label')}</span>
          <h2 className="satty-h2">{t(DATA + '.suite.title')}</h2>
          <div className="satty-suite-list">
            {features.map(function (item, i) {
              return (
                <div key={i} className="satty-suite-item">
                  <div className="satty-card-icon satty-card-icon--glass">
                    <SattyIcon name={iconKey(item.img)} size={24} />
                  </div>
                  <div>
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="satty-suite-visual">
          <div className="satty-suite-dashboard">
            <img src={t(DATA + '.suite.img_dashboard')} alt={t(DATA + '.suite.img_dashboard_alt')} />
          </div>
          <div className="satty-suite-app">
            <img src={t(DATA + '.suite.img_app')} alt={t(DATA + '.suite.img_app_alt')} />
          </div>
        </div>
      </div>
    </section>
  );
}

/* ─── LLUVIA / CASO DESTACADO ─── */
function SattyRain() {
  var t = useTranslation('common')[0];
  var features = useArray(t, DATA + '.rain.features');
  return (
    <section className="satty-screen satty-rain">
      <div className="satty-rain-inner satty-bleed-inner">
        <div className="satty-bleed-copy satty-bleed-copy--left">
          <span className="satty-eyebrow">{t(DATA + '.rain.label')}</span>
          <h2 className="satty-h2">{t(DATA + '.rain.title')}</h2>
          <p className="satty-lead satty-rain-lead">{t(DATA + '.rain.text')}</p>
          <div className="satty-rain-features">
            {features.map(function (item, i) {
              return (
                <article key={i} className="satty-rain-feature">
                  <div className="satty-card-icon satty-card-icon--soft">
                    <SattyIcon name={iconKey(item.img)} size={22} />
                  </div>
                  <h3 className="satty-rain-feature-title">{item.title}</h3>
                  <p className="satty-rain-feature-text">{item.text}</p>
                </article>
              );
            })}
          </div>
        </div>
        <div className="satty-rain-photo satty-bleed-photo">
          <img src={t(DATA + '.rain.img')} alt={t(DATA + '.rain.img_alt')} />
        </div>
      </div>
    </section>
  );
}

/* ─── CTA + FOOTER ─── */
function SattyCta() {
  var t = useTranslation('common')[0];
  return (
    <section id="contacto" className="satty-screen satty-cta">
      <div className="satty-cta-inner">
        <div className="satty-cta-logo">
          <SattyLogo size={52} />
        </div>
        <h2 className="satty-cta-title">{t(DATA + '.cta.title')}</h2>
        <p className="satty-cta-text">{t(DATA + '.cta.text')}</p>
        {/* Baja al formulario de la misma página en vez de abrir el cliente de
            correo: ahí se capturan industria y requerimiento. */}
        <a href="#contact" className="satty-btn satty-btn--primary satty-btn--lg">
          {t(DATA + '.cta.button')}
        </a>
      </div>
       
      <div className="satty-footer">
        {/* Footer: contacto y créditos
        <div className="satty-footer-inner">
          <div className="satty-footer-brand">
            <SattyLogo size={26} withOuterWave={false} />
            <span className="satty-footer-brand-name">{t(DATA + '.footer.brand')}</span>
            <span className="satty-footer-powered">{t(DATA + '.footer.powered')}</span>
          </div>
          <div className="satty-footer-links">
            <a href={'mailto:' + t(DATA + '.footer.email')}>{t(DATA + '.footer.email')}</a>
            <a href={t(DATA + '.footer.web_url')} target="_blank" rel="noopener noreferrer">
              {t(DATA + '.footer.web')}
            </a>
          </div>
        </div>*/}
      </div>
    </section>
  );
}

/* ─── PÁGINA ─── */
function Satty() {
  return (
    <div className="satty-page">
      <SattyHero />
      <SattyPillars />
      <SattyFlow />
      <SattyPipeline />
      <SattyNetwork />
      <SattyConnectivity />
      <SattyFailover />
      <SattyAlerts />
      <SattySuite />
      <SattyRain />
      <SattyCta />
      <div className="satty-contact">
        <ContactSection color={'#1E7A66'} variant={'satty'} />
      </div>
    </div>
  );
}

export default Satty;
